import script from "./examForm.vue?vue&type=script&setup=true&lang=js"
export * from "./examForm.vue?vue&type=script&setup=true&lang=js"

import "./examForm.vue?vue&type=style&index=0&id=53811848&lang=scss"

const __exports__ = script;

export default __exports__